/* eslint-disable import/no-unresolved */
<template>
  <MbsLayout :isNeedHeader="true">
      <template v-slot:header>
        <MbsHeader></MbsHeader>
      </template>

      <template v-slot:sidebar>
        <MbsMenu :menuListData="menuList"></MbsMenu>
        <div>12</div>
      </template>

      <template v-slot:content>
        <router-view />
      </template>
  </MbsLayout>
</template>

<script>
import { mapState } from 'vuex';
import MbsHeader from '@/components/mbs-design/packages/header/Header.vue';
import MbsMenu from '@/components/mbs-design/packages/menu/Menu2.vue';
import MbsLayout from '@/components/mbs-design/packages/layout/Layout.vue';

export default {
  name: 'BasicLayout',
  components: {
    MbsLayout,
    MbsHeader,
    MbsMenu,
  },
  data() {
    return {
      menuList: [],
    };
  },
  created() {
    this.menuList = this.accessedRoutes;
  },
  computed: {
    ...mapState({
      accessedRoutes: state => state.accessedRoutes,
    }),
  },
  methods: {
  },
};
</script>
